<template>
    <div class="costunit-list-table">
        <b-table :fields="fields" :items="tableItems" responsive striped>
            <template v-slot:head()="data">
                {{ data.label.toUpperCase() }}
            </template>
            <template v-slot:cell(costUnitText)="data">
                <span class="font-weight-bold">{{ emptyValuePlaceholder(data.value) }}</span>
                <span v-if="data.item.sourceText">
                    <br>
                    ({{ data.item.sourceText }})
                </span>
            </template>
            <template v-slot:cell(dateReceipt)="data">
                {{ formatDate(data.value) }}
            </template>
            <template v-slot:cell(amount)="data">
                <csp-costunit-amount-table
                    amount-property-prefix="amount"
                    :cost-unit="data.item" show-insurance-figure-label/>
            </template>
            <template v-slot:cell(paymentSums)="data">
                <csp-costunit-amount-table
                    amount-property-prefix="paymentsSum"
                    :cost-unit="data.item" is-payment sum-positive-class="text-success"/>
            </template>
            <template v-slot:cell(datePaid)="data">
                <template v-if="data.item.latestPayment.data">
                    {{ formatDate(data.item.latestPayment.data.attributes.datePaid) }}
                </template>
            </template>
            <template v-slot:cell(amountOpen)="data">
                <csp-costunit-amount-table
                    amount-property-prefix="amountOpen"
                    :cost-unit="data.item" highlight-insurance-payment sum-positive-class="text-danger">
                    <template v-slot:amountPrefix>
                        <span v-if="data.item.hasAmountAdjustment">*</span>
                    </template>
                </csp-costunit-amount-table>
            </template>
            <template v-slot:cell(comment)="data">
                <span style="white-space: pre-wrap">{{ data.value }}</span>
            </template>
        </b-table>
    </div>
</template>

<script>
    import {emptyValuePlaceholder} from '@js/functions/format';
    import {formatDate} from '@js/functions/date';

    export default {
        props: {
            costunits: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                fields: [
                    {
                        key: 'receipt',
                        label: this.$t('cost unit table header receipt'),
                        thClass: 'align-top text-center',
                        class: 'd-none d-lg-table-cell',
                        formatter: emptyValuePlaceholder,
                    },
                    {
                        key: 'costUnitText',
                        label: this.$t('cost unit table header text'),
                        thClass: 'align-top  text-center',
                    },
                    {
                        key: 'dateReceipt',
                        label: this.$t('cost unit table header date receipt'),
                        class: 'text-center',
                        thClass: 'align-top',
                    },
                    {
                        key: 'amount',
                        label: this.$t('cost unit table header amount'),
                        thClass: 'align-top text-center',
                    },
                    {
                        key: 'paymentSums',
                        label: this.$t('cost unit table header payments'),
                        thClass: 'align-top text-center',
                    },
                    {
                        key: 'datePaid',
                        label: this.$t('cost unit table header date paid'),
                        class: 'text-center',
                        thClass: 'align-top',
                    },
                    {
                        key: 'amountOpen',
                        label: this.$t('cost unit table header amount open'),
                        thClass: 'align-top text-center',
                    },
                    {
                        key: 'comment',
                        label: this.$t('cost unit table header amount comment'),
                        thClass: 'align-top',
                        tdClass: 'text-center',
                        class: 'd-none d-lg-table-cell',
                        formatter: emptyValuePlaceholder,
                    },
                ],
            }
        },
        computed: {
            tableItems() {
                const tableItems = [];
                this.costunits.forEach((item) => {
                    tableItems.push(
                        {
                            id: item.id,
                            ...item.attributes,
                        }
                    );
                });
                return tableItems;
            },
        },
        methods: {
            emptyValuePlaceholder,
            formatDate,
        },
    }
</script>
